/**
 * Times a customer reads, printed on the calendar the backend's customer-facing text uses.
 */

/** The customer calendar every customer-facing time is printed on (GMT+7, no DST). */
const CUSTOMER_UTC_OFFSET_MS = 7 * 60 * 60 * 1000;

const pad = (value: number) => String(value).padStart(2, "0");

/**
 * Epoch milliseconds of a UTC timestamp from the API, or null when it does not parse. A value
 * serialised without an offset is still UTC and must not be read as the viewer's local time.
 */
export function parseUtcMs(isoUtc: string): number | null {
  const hasOffset = /(Z|[+-]\d{2}:?\d{2})$/i.test(isoUtc);
  const ms = Date.parse(hasOffset ? isoUtc : `${isoUtc}Z`);
  if (Number.isNaN(ms)) {
    return null;
  }

  return ms;
}

/**
 * `HH:mm dd/MM/yyyy` on Indochina Time, whatever the viewer's own timezone. Null when the value
 * does not parse.
 */
export function formatCustomerTime(isoUtc: string): string | null {
  const ms = parseUtcMs(isoUtc);
  if (ms === null) {
    return null;
  }

  const local = new Date(ms + CUSTOMER_UTC_OFFSET_MS);
  const time = `${pad(local.getUTCHours())}:${pad(local.getUTCMinutes())}`;
  const date = `${pad(local.getUTCDate())}/${pad(local.getUTCMonth() + 1)}/${local.getUTCFullYear()}`;
  return `${time} ${date}`;
}
